import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg'

function KeywordDescription ({ localDescription, setLocalDescription }) {
  const handleDescriptionChange = e => {
    const { name, value } = e.target
    setLocalDescription(prev => ({
      ...prev,
      [name]: value
    }))
  }

  return (
    <section className={styles.keywordDescriptionSection}>
      <div className={styles.keywordDescriptionContainer}>
        <div className={styles.keywordDescriptionColumn}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              marginBottom: '8px'
            }}
          >
            <label className={styles.KeywordDescriptionLabel} htmlFor='value'>
              Description
            </label>
            <Tooltip
              title='The description of the business.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Description help'
                width={14}
                height={14}
                style={{ cursor: 'pointer' }}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            placeholder='Keyword'
            className={styles.KeywordDescriptionInput}
            type='text'
            id='value'
            name='value'
            autoComplete='off'
            value={localDescription?.value || ''}
            onChange={handleDescriptionChange}
          />
        </div>
      </div>
    </section>
  )
}

export default KeywordDescription
